/**
 * SpeciesVisual.js
 * 
 * Displays the appropriate visual for the Species section.
 * Extracted from legacy MainRight.js logic using IlAdd active="sp".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const SpeciesVisual = ({ down_type, origin, lower }) => {
  const isRenuLocal = (type) => type && type.toLowerCase().includes("renu");
  // Replicating legacy IlAdd logic for 'active="sp"' in MainRight.js
  // This logic determines the background image based on down_type and origin.

  const getSpeciesVisualSrc = () => {
    const dt = down_type;
    const o = origin;

    const isRenuLocal = (val) => val && val.toLowerCase().includes("renu");
    
    const determinedDt = (() => {
      if (dt === 'White Goose') return "wgd";
      if (dt === 'Grey Goose') return "ggd";
      if (dt === 'Muscovy White Duck') return "mwd";
      if (dt === 'Grey Duck') return "gdd";
      if (dt === 'Muscovy Grey Duck') return "mgd";
      return "wdd"; // Default
    })();

    const l = lower || "upper"; // Default to "upper" if lower prop is not provided

    if (isRenuLocal(dt) || isRenuLocal(o)) { 
      return `/img/species/species-renu-${l}.jpeg`;
    } else {
      const determinedOrigin = o === 'Hungary' ? "hu" : (o === 'Europe' ? "eu" : "cn");
      return `/img/species/species-${determinedDt}-${determinedOrigin}-${l}.jpeg`;
    }
  };



  // Mimicking the legacy IlAdd return structure: a div with className="il-add" and backgroundImage style
  return (
    <div className="il-add" data-source="SpeciesVisual" data-beta-flow="true" style={{ backgroundImage: `url(${getSpeciesVisualSrc()})` }}></div>
  );
};

